import React from "react"
import BlockWrapper from "../technical/BlockWrapper"
import SliderWrapper from "../technical/SliderWrapper"
import Headline from "@yumgmbh/gatsby-theme-yum-components/src/components/atoms/Headline"
import Link from "@yumgmbh/gatsby-theme-yum-components/src/components/atoms/Link"
import { ArrowRight16 } from "@carbon/icons-react"
import Image from "@yumgmbh/gatsby-theme-yum-components/src/components/atoms/Image"
import { useTranslation } from "react-i18next"
import NewFlag from "../atoms/NewFlag"
import useDateCheck from "../../hooks/useDateCheck"

const VariantCard = ({ item, className }) => {
  const displayNewFlag = useDateCheck(
    item.node.parentProduct.isNewToggle.value,
    item.node.parentProduct.isNewFromDate?.value,
    item.node.parentProduct.isNewUntilDate?.value
  )

  return (
    <div className={className}>
      <Link
        className="flex flex-col w-full h-full group"
        link={item.node.fullSlug}
      >
        <div
          className="relative block w-full overflow-hidden border border-gray-300 aspect-square"
          data-product-attr-id={item.node.productImages?.originId}
        >
          {displayNewFlag === true && <NewFlag type="gridCard" />}
          {item.node.productImages?.items[0] && (
            <Image
              className="w-full h-auto min-h-full"
              image={item.node.productImages.items[0].value}
              aspectRatio="1by1"
              fitIn="true"
              fillColor="ffffff"
            />
          )}
        </div>
        <div className="flex-1 p-4 -mt-px bg-gray-100 border border-gray-300">
          <div
            className="font-bold group-hover:text-primary hyphens-auto"
            data-product-attr-id={item.node.displayName?.originId}
          >
            {item?.node?.displayName?.value}
          </div>
          {item?.node?.changeOverLabel && (
            <div>{item?.node?.changeOverLabel?.value}</div>
          )}
        </div>
      </Link>
    </div>
  )
}

const RelatedVariantsCardsSlider = ({ items, headline_i18n_key, _attrId }) => {
  const { t } = useTranslation()

  let showSlides = 4

  return (
    <BlockWrapper
      block={{ component: "related_variants_cards_slider" }}
      blockWidth="container"
      showHeadline="false"
    >
      <div
        id="variants"
        className="flex flex-row items-baseline justify-between pb-10"
        data-product-attr-id={_attrId}
      >
        <Headline
          headline={t(headline_i18n_key)}
          headlineLevel="h3"
          tagName="h2"
        />
      </div>
      {items.length > 0 && (
        <SliderWrapper showSlides={showSlides} _uid={_attrId.replace(",", "_")}>
          {items.map((item, index) => (
            <VariantCard
              key={index}
              item={item}
              className="flex flex-col h-full"
            />
          ))}
        </SliderWrapper>
      )}
    </BlockWrapper>
  )
}

export default RelatedVariantsCardsSlider
